import { component } from '../../framework/component.decorator';
import { events } from '../../events';
import { p } from '../../templating/p.element';
import { span } from '../../templating/span.element';
import { fetchCount } from '../../utils/fetch-count.fn';
import { nextTick } from '../../utils/next-tick.fn';
import { updateCount } from '../../utils/update-count.fn';
import { BaseComponent } from '../../framework/base.component';
import styles from './counter.component.scss';
import { OnDestroy } from '../../framework/on-destroy.interface';
import { store } from '../../store';
import { OnInit } from '../../framework/on-init.interface';

@component({
  selector: 'app-counter',
  styles,
})
export class CounterComponent
  extends BaseComponent<CounterComponent>
  implements OnInit, OnDestroy
{
  private onConvertFinishedWithoutErrorsListener = (event: {
    files: FileList | File[];
  }) => this.onConvertFinishedWithoutErrors(event);

  constructor() {
    super(CounterComponent);
  }

  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    let count = store.get('lastCount');

    if (count === undefined) {
      count = await fetchCount();
    } else {
      count = '';
      fetchCount().then((c) => nextTick(() => this.setCount(c)));
    }

    return p(count === undefined ? 'hide' : '', [
      span('count-prefix', {
        textContent: `We've collectively converted`,
      }),
      span('count', {
        textContent: count,
      }),
      span('count-suffix', { textContent: 'files' }),
    ]);
  }

  async onInit(): Promise<void> {
    events.on(
      'convert-finished-without-errors',
      this.onConvertFinishedWithoutErrorsListener
    );
  }

  onDestroy(): void {
    events.off(
      'convert-finished-without-errors',
      this.onConvertFinishedWithoutErrorsListener
    );
  }

  async setCount(count: string | undefined) {
    if (count === undefined) {
      this._root.querySelector('p')?.classList?.add('hide');

      return;
    }

    store.set('lastCount', count);
    const count$ = this._root.querySelector('.count');

    if (count$ !== null) {
      count$.textContent = count;
      this._root.querySelector('p')?.classList?.remove('hide');
    }
  }

  async onConvertFinishedWithoutErrors({
    files,
  }: {
    files: FileList | File[];
  }) {
    const newCount = await updateCount(files.length);

    this.setCount(newCount);
  }
}
